import React, { useEffect } from 'react';
import moment from 'moment';
import { Radio, Table, Icon, DatePicker } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { REQUEST_GET_All_USERS_STATS } from '../../Redux/constants/constants';

const { Column } = Table;
const { MonthPicker } = DatePicker;

const AllUsersStatsTable = () => {
  const dispatch = useDispatch();
  const allStats = useSelector((state) => state.allUsersStats);
  const currentMonth = moment().format('YYYY-MM-DD');
  const currentMonthForPicker = moment();

  useEffect(() => {
    dispatch({ type: REQUEST_GET_All_USERS_STATS, payload: currentMonth });
  }, []);

  const changeMonth = (selectedDate) => {
    const date = selectedDate ? selectedDate : currentMonthForPicker;
    const dateFormated = moment(date).format('YYYY-MM-DD');
    dispatch({ type: REQUEST_GET_All_USERS_STATS, payload: dateFormated });
  };

  return (
    <>
      <MonthPicker
        onChange={changeMonth}
        defaultValue={currentMonthForPicker}
      />
      <Table
        pagination={false}
        rowKey={(record) => record.id}
        dataSource={allStats}
        scroll={{ x: 1500 }}
      >
        <Column width={200} title="Użytkownik" dataIndex="name" key="name" />
        <Column
          width={140}
          title="Godziny w miesiacu"
          dataIndex="payHoursInMonth"
          key="payHoursInMonth"
        />
        <Column title="Razem" dataIndex="sumSum" key="sumSum" />
        <Column
          title="Suma godzin podstawowych"
          dataIndex="sumWorkHours"
          key="sumWorkHours"
        />
        <Column
          title="Dopełnienie z nadgodzin"
          dataIndex="sumCompensatoryHours"
          key="sumCompensatoryHours"
        />
        <Column
          title="L4"
          dataIndex="sumSickLeaveHours"
          key="sumSickLeaveHours"
        />
        <Column
          title="Urlop"
          dataIndex="sumVacationHours"
          key="sumVacationHours"
        />
        <Column
          title="Urlop z nadgodzin"
          dataIndex="sumOvertimeLeaveHours"
          key="sumOvertimeLeaveHours"
        />
        <Column
          title="Urlop bezpłatny"
          dataIndex="sumUnpaidLeaveHours"
          key="sumUnpaidLeaveHours"
        />
        <Column
          title="Zalogowane nadgodziny"
          dataIndex="sumOvertimeHours"
          key="sumOvertimeHours"
        />
      </Table>
    </>
  );
};

export default AllUsersStatsTable;
